import { createSignal, JSX, onCleanup, splitProps } from "solid-js";
import { Button } from "@repo/ui/button";
import { ControlProps } from "./utils";

export function Control(props: ControlProps): JSX.Element {
  const [local, others] = splitProps(props, [
    "class",
    "editor",
    "title",
    "key",
    "onChange",
    "isActive",
    "children",
  ])

  const isControlActive = () => {
    if (local.isActive) {
      return local.isActive(local.editor);
    }
    return local.editor.isActive(local.key);
  };

  const [isPressed, setIsPressed] = createSignal(isControlActive());

  const updatePressedState = () => {
    const newState = isControlActive();
    setIsPressed(newState);
  };

  // Listen to all relevant editor events
  // props.editor.on("selectionUpdate", updatePressedState);
  // props.editor.on("update", updatePressedState);
  local.editor.on("transaction", updatePressedState);

  onCleanup(() => {
    // props.editor.off("selectionUpdate", updatePressedState);
    // props.editor.off("update", updatePressedState);
    local.editor.off("transaction", updatePressedState);
  });

  const handleToggle = () => {
    if (local.key !== "code") {
      local.editor.chain().focus().unsetMark("code").run();
    }
    // Then apply the new formatting
    local.onChange();

    updatePressedState();
  };

  return (
    <Button
      variant="ghost"
      size="xs"
      class={`${local.class} flex items-center justify-center rounded hover:text-gray-50 hover:bg-gray-900`}
      classList={{
        "text-color-600 bg-gray-200/25 hover:bg-gray-400/50": isPressed(),
      }}
      title={local.title}
      onClick={handleToggle}
      {...others}
    >
      {local.children}
    </Button>
  );
}
